const EDSJobMap = {
  workDone: [
    'Built a click-to-set radius search: clicking any point on the map generates a filter radius, computes distance client-side, and narrows the job list in real time with no server round-trip',
    'Synchronized map and table state through a shared reducer, so pin selection highlights the matching table row and row selection pans the map to the corresponding pin',
    'Designed the interaction to update two independent UI surfaces (map + table) from a single user action, reducing the steps officers need to locate and evaluate nearby jobs',
    'Integrated Mapbox GL JS with custom geometry utilities (haversine distance, circle generation) to avoid pulling in a heavier third-party geo library',
  ],
  tech: [
    'Mapbox GL JS',
    'React',
    'Context API',
    'useReducer',
    'JavaScript',
    'custom geospatial utilities (haversine distance, circle polygon generation)',
  ],
  // liveLink: '',
  features: [
    { title: 'List-to-map sync', image: { link: require('./edsJobMapAssests/eds-map-1.gif').default } },
    { title: 'Pin-to-list sync', image: { link: require('./edsJobMapAssests/eds-map-2.gif').default } },
    { title: 'Click-to-filter radius search', image: { link: require('./edsJobMapAssests/eds-map-3.gif').default } },
    { title: 'liveUpdate', image: { link: require('./edsJobMapAssests/eds-map-4.gif').default } },
  ],
};

export default EDSJobMap;
